import { render } from "./HeroiconsSolidStatusOffline.vue?vue&type=template&id=1f776b0c"
const script = {}

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidStatusOffline.vue"]])

export default __exports__